import { Link } from "react-router-dom";

/**
 * Shared centred card layout for every /signup /login /verify /reset page.
 * Cream page, single card, script wordmark at the top so the auth pages
 * still feel like Willoah and not a generic template.
 */
export default function AuthLayout({ title, subtitle, children, footer }) {
  return (
    <main className="min-h-[calc(100vh-64px)] flex items-center justify-center px-6 py-14 bg-[#FBF8F1]">
      <div className="w-full max-w-md" data-testid="auth-card">
        <div className="text-center mb-8">
          <Link to="/" className="inline-block" data-testid="auth-wordmark-link">
            <div className="font-serif-display text-4xl text-[#4E5A3D] leading-none">Willoah</div>
            <div className="accent-label text-[10px] text-[#B79256] mt-1">real life. real ideas.</div>
          </Link>
        </div>
        <div className="bg-white/70 backdrop-blur rounded-3xl border border-[#B79256]/25 p-8 shadow-[0_20px_60px_rgb(42,40,35,0.06)]">
          <h1 className="font-serif-display text-3xl text-[#2A2823] leading-tight" data-testid="auth-title">
            {title}
          </h1>
          {subtitle && (
            <p className="text-sm text-[#2A2823]/65 mt-2 leading-relaxed" data-testid="auth-subtitle">
              {subtitle}
            </p>
          )}
          <div className="mt-6">{children}</div>
        </div>
        {footer && (
          <div className="text-center text-sm text-[#2A2823]/65 mt-6" data-testid="auth-footer">
            {footer}
          </div>
        )}
      </div>
    </main>
  );
}

/** Shared helper: normalize FastAPI error responses to a display string. */
export function formatApiError(err) {
  if (!err) return "Something went wrong. Please try again.";
  if (!err.response) return "Couldn't reach the server. Check your connection and try again.";
  const detail = err.response.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((d) => (d && typeof d.msg === "string" ? d.msg : ""))
      .filter(Boolean)
      .join(" · ");
  }
  return `Something broke on our end (${err.response.status}). Please try again.`;
}
